import React from "react";
export const PageColor = React.createContext();
